import PaneProps from './PaneProps'
import Vue from 'vue'

let KendoSplitterPane = {
    name: 'kendo-splitter-pane',
    render () {
        return Vue.prototype._e
    },
    mixins: [PaneProps]
}

export default KendoSplitterPane


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoSplitter/KendoSplitterPane.js